import React, { Component } from "react";
import { Link } from "react-router-dom";
import Menu from "./components/menu";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import MetaTags from "../../element/MetaTags";
const bg = require("../../../images/servicehero.png");

class BondCleaning extends Component {
  render() {
    return (
      <>
        <MetaTags
          title="Bond Cleaning Services Gold Coast | End of Lease Cleaning"
          description="Professional bond cleaning services in Gold Coast. We ensure you get your bond back with our thorough end of lease cleaning."
          keywords="bond cleaning gold coast, end of lease cleaning, exit cleaning, bond back cleaning"
        />
        <Header />
        <div className="page-content bg-white">
          <div
            className="dlab-bnr-inr  bg-pt"
            style={{ backgroundImage: "url(" + bg + ")" }}
          >
            <div className="container">
              <div className="dlab-bnr-inr-entry">
                <h1 className="text-white">Bond Cleaning</h1>
                <div className="breadcrumb-row">
                  {/* <ul className="list-inline">
                    <li>
                      <Link to="/">Home</Link>
                    </li>
                    <li>Service</li>
                    <li>Service Details</li>
                  </ul> */}
                </div>
              </div>
            </div>
          </div>

          <div className="content-block">
            <div className="section-full content-inner">
              <div className="container">
                <div className="row">
                  <Menu />
                  <div className="col-xl-9 col-lg-8 col-md-7 m-b30">
                    <div className=" col-md-12 m-b30">
                      <div className="dlab-box">
                        {/* <div className="dlab-media">
                            {" "}
                            <Link to="#">
                              <img
                                src={require("../../images/about/pic4.jpg")}
                                alt=""
                              />
                            </Link>{" "}
                          </div> */}
                        <div className="dlab-info">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">
                              Here’s Why You Should Consider Trained Cleaners
                              for a Quality Bond Cleaning at an Affordable Price
                              at Gold Coast, QLD
                            </Link>
                          </h4>
                          <p>
                            Are you planning to shift your accommodation? Do you
                            know it is required by law to clean your
                            accommodation to refund the bond deposit you paid
                            when you leased the property (according to the real
                            estate agent)?
                          </p>
                        </div>
                        <div className="dlab-info m-t30 ">
                          <h4 className="dlab-title m-t0">
                            <Link to="#">What is Bond Cleaning?</Link>
                          </h4>
                          <p>
                            Bond cleaning or end-of-lease cleaning is a
                            mandatory requirement by law of an end-of-lease
                            cleaning. If the contract states professional
                            cleaners must clean the property, it is compulsory
                            to hire cleaning experts.
                          </p>
                          <p>
                            The tenant must bear the charges for bond cleaning
                            of the rental property. End-of-lease cleaning
                            includes cleaning the entire property. It is a
                            necessary process that requires a particular time
                            and energy.
                          </p>
                          <p>
                            Bond cleaning includes windows cleaning, wall
                            washing, vacuuming, steam cleaning, carpet cleaning,
                            tidying the garden, cleaning the pools (if any),
                            dusting the light fittings, oven cleaning, surface
                            cleaning, and more tasks that are made easy with
                            professional cleaning. Professional cleaners use
                            industrial-grade products, equipment, and modern
                            techniques to complete the job easier.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="dlab-box">
                      <div className="dlab-info m-t30">
                        <h4 className="dlab-title m-t0">
                          <Link to="#">
                            Meet Our Talented Bond Cleaners at Gold Coast!
                          </Link>
                        </h4>
                        <p>
                          It might not be convenient for every occupant to
                          perform a standardized cleaning while arranging for
                          the move-out. It can be a challenging and
                          time-consuming process. We understand you! Hiring a
                          professional, reasonably priced bond cleaning company
                          helps you return the property with guaranteed
                          sanitation and cleanliness and saves you money while
                          allowing you to focus less on the bond cleaning
                          hassle.
                        </p>
                        <p>
                          Need clarification in searching for a quality but
                          cheap bond cleaning service? Our team at Kangaroo
                          Shine Property Services in Gold Coast is available to
                          provide you with the best bond cleaning service you
                          expect.
                        </p>
                        <p>
                          We are a trusted company that offers a comprehensive
                          list of cleaning services in Gold Coast, QLD and to
                          nearby areas including Main Beach, Southport, Nerang
                          and Varsity Lakes. Our team of experts has more than
                          five years of experience in providing you with various
                          cleaning services. Our team will inspect the property,
                          commence the job and complete it as required.
                        </p>
                        <p>
                          Drop us a message or call us at +61424888804 to
                          schedule an appointment!
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}
export default BondCleaning;
